import React from "react";
import { Link } from "react-router-dom";
import { WorkoutTemplatePreview } from "../../libs/workout/types";
import { DEFAULT_CONTAINER_COLOR } from "../ProgressionsTable/ColorPicker";
import { DownloadPdfButton } from "../DownloadPdfButton";

export const WORKOUT_DRAG_TYPE = "application/fitshape-workout";

type Props = {
  template: WorkoutTemplatePreview;
  color?: string;
  /** Se valorizzato, mostra l'azione "sposta nella radice" (siamo dentro una cartella). */
  onMoveToRoot?: () => void;
  selectionMode?: boolean;
  selected?: boolean;
  onToggleSelect?: () => void;
};

export const WorkoutCard: React.FC<Props> = ({
  template,
  color = DEFAULT_CONTAINER_COLOR,
  onMoveToRoot,
  selectionMode,
  selected,
  onToggleSelect,
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData(
      WORKOUT_DRAG_TYPE,
      JSON.stringify({
        id: template.id,
        idContainer: template.idContainer ?? null,
      })
    );
    e.dataTransfer.effectAllowed = "move";
  };

  return (
    <div
      draggable={!selectionMode}
      onDragStart={selectionMode ? undefined : handleDragStart}
      onClick={selectionMode ? onToggleSelect : undefined}
      className={`relative bg-white dark:bg-gray-800 border-2 rounded-xl shadow-sm hover:shadow-md transition-all p-5 flex flex-col gap-2 ${
        selectionMode ? "cursor-pointer" : "cursor-grab active:cursor-grabbing"
      } ${selected ? "ring-2 ring-blue-500 border-blue-400" : ""}`}
      style={{ borderColor: selected ? undefined : `${color}30` }}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-3">
          {selectionMode && (
            <input
              type="checkbox"
              checked={!!selected}
              onChange={onToggleSelect}
              onClick={(e) => e.stopPropagation()}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 flex-shrink-0"
            />
          )}
          <h3 className="font-semibold text-gray-900 dark:text-white text-sm">
            {template.name}
          </h3>
        </div>
        {!selectionMode && onMoveToRoot && (
          <button
            type="button"
            title="Sposta fuori dalla cartella"
            onClick={onMoveToRoot}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 3a1 1 0 01.707.293l4 4a1 1 0 01-1.414 1.414L11 6.414V16a1 1 0 11-2 0V6.414L6.707 8.707a1 1 0 01-1.414-1.414l4-4A1 1 0 0110 3z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
      {template.note && (
        <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2">
          {template.note}
        </p>
      )}
      {!selectionMode && (
        <div className="mt-1 flex items-center gap-2">
          <Link
            to={"/workouts/" + template.id}
            className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline"
          >
            Visualizza
          </Link>
          <DownloadPdfButton
            workoutId={template.id + ""}
            workoutName={template.name}
          />
        </div>
      )}
    </div>
  );
};
